/* Generated from shared/ by tools/sync-shared.sh. Don't edit; edit shared/ and run it again. */
/* The colour tokens (shared/nowish.json "colors"): --name is the colour, --name-rgb its r, g, b for rgba(). */
:root {
  --accent: #007AFF;
  --accent-rgb: 0, 122, 255;
  --accent-fill: #E5F2FF;
  --accent-fill-rgb: 229, 242, 255;
  --now: #22C55E;
  --now-rgb: 34, 197, 94;
  --now-fill: #E6FFF4;
  --now-fill-rgb: 230, 255, 244;
  --now-text: #15803D;
  --now-text-rgb: 21, 128, 61;
  --soon: #1E92E6;
  --soon-rgb: 30, 146, 230;
  --soon-fill: #DEF7FC;
  --soon-fill-rgb: 222, 247, 252;
  --soon-text: #0B6CB3;
  --soon-text-rgb: 11, 108, 179;
  --starred: #FFAA00;
  --starred-rgb: 255, 170, 0;
  --selected: #222222;
  --selected-rgb: 34, 34, 34;
  --text: #222222;
  --text-rgb: 34, 34, 34;
  --muted: #6A6A6A;
  --muted-rgb: 106, 106, 106;
  --fill: #F7F7F7;
  --fill-rgb: 247, 247, 247;
  --line: #DDDDDD;
  --line-rgb: 221, 221, 221;
  --line-soft: #EBEBEB;
  --line-soft-rgb: 235, 235, 235;
  --surface: #FFFFFF;
  --surface-rgb: 255, 255, 255;
  --on-color: #FFFFFF;
  --on-color-rgb: 255, 255, 255;
  --ink: #1A1A1A;
  --ink-rgb: 26, 26, 26;
  --danger: #D93025;
  --danger-rgb: 217, 48, 37;
  --danger-fill: #FCE8E6;
  --danger-fill-rgb: 252, 232, 230;
  --warning: #B25E09;
  --warning-rgb: 178, 94, 9;
  /* Cards' corner radius (shared/nowish.json "cardRadius"). */
  --radius: 16px;
}
